import { Theme } from 'morpheus-ui';
import { tv } from 'tailwind-variants';

const selectGroupClasses = tv({
  base: 'flex flex-col w-full',
  variants: {
    size: {
      md: '',
      lg: '',
    },
    disabled: {
      true: '',
    },
  },
});

const listBoxClasses = tv({
  base: 'relative',
  variants: {
    size: {
      md: '',
      lg: '',
    },
    disabled: {
      true: '',
    },
  },
});

const borderWidthKeys = Object.keys(Theme.borderWidth);
const listBoxButtonClasses = tv(
  {
    base: 'text-mono-color-black peer flex gap-xs justify-between text-left rounded-md border-hairline ui-not-open:border-mono-color-dark bg-mono-color-white w-full ui-open:border-brand-color-primary-pure ui-open:shadow-focused ui-not-open:shadow-[none] transition-all',
    variants: {
      size: {
        md: 'p-3 text-md',
        lg: 'p-4 text-lg',
      },
      disabled: {
        true: 'cursor-not-allowed text-mono-color-black bg-mono-color-light',
      },
      hasError: {
        true: 'ui-not-open:border-feedback-color-error-pure ui-not-open:shadow-error ui-open:border-feedback-color-error-pure ui-open:shadow-error',
      },
    },
  },
  {
    twMergeConfig: {
      theme: {
        borderWidth: borderWidthKeys,
      },
    },
  }
);

const listBoxButtonIconClasses = tv({
  base: '',
});

const labelClasses = tv({
  base: 'text-mono-color-black text-sm absolute bg-gradient-to-b from-color-transparent from-42.28% via-mono-color-white via-43.53% to-mono-color-white to-52.68% px-1 transition-all select-none pointer-events-none',
  variants: {
    size: {
      md: `
        left-3
        -top-2 
        
        ui-open:-top-2
        ui-open:text-sm   

        ui-not-open:top-3
        ui-not-open:text-md
    `,
      lg: `
        left-3
        -top-2

        ui-open:-top-2
        ui-open:text-sm   

				ui-not-open:top-3
        ui-not-open:text-lg
      `,
    },
    disabled: {
      true: 'text-mono-color-black',
    },
    isSelected: {
      true: '',
    },
    hasError: {
      true: 'ui-open:text-feedback-color-error-pure ui-not-open:text-mono-color-black',
    },
  },
  compoundVariants: [
    {
      hasError: true,
      isSelected: true,
      className:
        'text-feedback-color-error-pure ui-not-open:text-feedback-color-error-pure',
    },
    {
      disabled: true,
      isSelected: false,
      className: 'bg-none',
    },
    {
      disabled: true,
      isSelected: true,
      className:
        'bg-gradient-to-b from-color-transparent from-42.28% via-bg-mono-color-light via-43.53% to-bg-mono-color-light to-52.68%',
    },
    {
      isSelected: false,
      size: 'lg',
      className: 'text-lg top-3.5',
    },
    {
      isSelected: false,
      size: 'md',
      className: 'text-md top-3.5',
    },
    {
      isSelected: true,
      size: 'lg',
      className: 'ui-not-open:-top-2 ui-not-open:text-sm',
    },
    {
      isSelected: true,
      size: 'md',
      className: 'ui-not-open:-top-2 ui-not-open:text-sm',
    },
  ],
});

const helperTextClasses = tv({
  base: 'text-sm ui-not-open:text-mono-color-dark pt-1 focus:text-mono-color-black ui-open:text-mono-color-black',
  variants: {
    disabled: {
      true: 'text-mono-color-dark',
    },
  },
});
const errorTextClasses = tv({
  base: 'text-sm ui-not-open:text-feedback-color-error-pure pt-1 focus:text-mono-color-black ui-open:text-red-500',
  variants: {
    disabled: {
      true: 'text-mono-color-dark',
    },
  },
});

const listBoxOptionsClasses = tv({
  base: 'text-mono-color-darkest flex flex-col gap-1 p-2 mt-2 bg-color-lighter rounded-md shadow-level-2 absolute z-10 w-full overflow-y-auto max-h-80',
  variants: {
    size: {
      md: 'text-md',
      lg: 'text-lg',
    },
    disabled: {
      true: '',
    },
  },
});

const listBoxOptionClasses = tv({
  base: 'p-2 cursor-pointer transition-all select-none rounded-md',
  variants: {
    disabled: {
      true: 'text-mono-color-dark cursor-not-allowed',
    },
    active: {
      true: '',
    },
    selected: {
      true: 'bg-brand-color-primary-lighter text-brand-color-primary-pure',
    },
  },
});

export {
  errorTextClasses,
  helperTextClasses,
  labelClasses,
  listBoxButtonClasses,
  listBoxButtonIconClasses,
  listBoxClasses,
  listBoxOptionClasses,
  listBoxOptionsClasses,
  selectGroupClasses
};

